import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getQuizById } from '../data/quizRegistry';
import { updateMetaTags } from '../utils/seoHelpers';
import ProgressBar from '../components/progressBar';

const QuizPage: React.FC = () => {
  const { quizId } = useParams<{ quizId: string }>();
  const navigate = useNavigate();
  const quiz = quizId ? getQuizById(quizId) : null;

  const shuffledIndices = useMemo(() => {
    if (!quiz) return [];
    const indices = quiz.questions.map((_: unknown, i: number) => i);
    for (let i = indices.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [indices[i], indices[j]] = [indices[j], indices[i]];
    }
    return indices;
  }, [quiz]);

  const [currentStep, setCurrentStep] = useState(0);
  const [shuffledAnswers, setShuffledAnswers] = useState<boolean[]>([]);
  const [slideClass, setSlideClass] = useState('question-slide-in');
  const scoreRef = useRef(0);

  useEffect(() => {
    if (quiz) {
      updateMetaTags(quiz.seo.title, quiz.seo.description);
    }
  }, [quiz]);

  if (!quiz) {
    navigate('/', { replace: true });
    return null;
  }

  const questions = quiz.questions;
  const originalIndex = shuffledIndices[currentStep];
  const question = currentStep < questions.length ? questions[originalIndex] : null;

  const handleButtonClick = (isYes: boolean) => {
    if (navigator.vibrate) {
      navigator.vibrate(50);
    }

    const questionData = questions[originalIndex];
    const addedScore = isYes ? questionData.yesScore : questionData.noScore;
    const newScore = scoreRef.current + addedScore;
    scoreRef.current = newScore;
    const newShuffledAnswers = [...shuffledAnswers, isYes];
    setShuffledAnswers(newShuffledAnswers);

    advanceQuestion(newScore, newShuffledAnswers);
  };

  const advanceQuestion = (currentScore: number, currentShuffledAnswers: boolean[]) => {
    if (currentStep + 1 >= questions.length) {
      const orderedAnswers = new Array<boolean>(questions.length);
      currentShuffledAnswers.forEach((answer, stepIdx) => {
        orderedAnswers[shuffledIndices[stepIdx]] = answer;
      });

      navigate(`/quiz/${quizId}/loading`, {
        state: { score: currentScore, answers: orderedAnswers },
      });
    } else {
      setSlideClass('question-slide-out');
      setTimeout(() => {
        setCurrentStep((prev) => prev + 1);
        setSlideClass('question-slide-in');
      }, 300);
    }
  };

  if (!question) return null;

  return (
    <div className="wrapper-question">
      <div className="container">
        <ProgressBar currentQuestionIndex={currentStep} totalQuestions={questions.length} />
        <div className={slideClass}>
          <p>{question.description}</p>
        </div>
        <div className="questionbutton">
          <button
            className="button button--ujarak button--border-medium button--round-s button--text-thick"
            onClick={() => handleButtonClick(true)}
          >
            네
          </button>
          <button
            className="button button--ujarak button--border-medium button--round-s button--text-thick"
            onClick={() => handleButtonClick(false)}
          >
            아니오
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuizPage;
